import dayjs from "dayjs";

export const FormHelper = {
  getQueryParamsDateTypeRange: (queryParams: object) => {
    const postfixes = ["_started_at", "_stopped_at"];
    const keys = Object.keys(queryParams);
    const matches = keys.filter((key) =>
      postfixes.some((postfix) => key.endsWith(postfix))
    );

    const dateType = matches[0].endsWith("_started_at")
      ? matches[0].replace("_started_at", "")
      : matches[0].replace("_stopped_at", "");

    const startKey = `${dateType}_started_at` as keyof object;
    const startDayjs = dayjs(queryParams[startKey]);
    const stoppedKey = `${dateType}_stopped_at` as keyof object;
    const stoppedDayjs = dayjs(queryParams[stoppedKey]);
    return { dateType, dateRange: [startDayjs, stoppedDayjs] };
  },
};
